import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { devtoolsDefaultOption } from '@/lib/zustand';

type PhaseBannerStore = {
  show: boolean;
  setShow: (show: boolean) => void;
};

export const usePhaseBanner = create<PhaseBannerStore>()(
  devtools(
    set => ({
      show: true,
      setShow: show =>
        set(() => ({
          show: show,
        })),
    }),
    { ...devtoolsDefaultOption, name: 'usePhaseBanner' },
  ),
);
